import { mapBorderColors, mapFillColors, mapboxTextColors } from '@/components/mixins/constants'

import mapsIconGreen from '@/assets/maps_icon_green.png'
import mapsIconMulti from '@/assets/maps_icon_multi.png'
import mapsIconPinBlue from '@/assets/maps_icon_pin_blue.png'
import mapsIconRed from '@/assets/maps_icon_red.png'
import mapsIconYellow from '@/assets/maps_icon_yellow.png'

const config = {
  MAP_DEFAULT_ZOOM: 16,
  MAP_DEFAULT_ZOOMED_OUT: 4.5,
  MAP_DEFAULT_CENTER: { lat: 51.38507, lng: 10.262415 },
  MAP_LOADING_DELAY: 500,
  MAPBOX_TOKEN: 'pk.eyJ1IjoiYmhlcGJ1cm4iLCJhIjoiY2t6cGw2c2N4M2oxazJubnluMDRmMml2eCJ9.bFHgl2FpFHXN4rx09uOpng',
  BASE_API_URL: process.env.VUE_APP_BASE_API,
  BASE_APP_URL: process.env.VUE_APP_BASE_APP,
  MAPBOX_BOX_COLORS: {
    SITE: mapFillColors.BLUE,
    AREA: mapFillColors.GREEN,
    ZONE: mapFillColors.RED,
    BORDER: mapBorderColors.BLACK,
    TEXT: mapboxTextColors.WHITE,
  },
  MAPBOX_BOX_BORDER_WIDTH: {
    SITE: 2,
    AREA: 1,
    ZONE: 1,
    CLUSTER_STROKE: 1,
  },
  MAPBOX_BOX_OPACITY: {
    SITE: 0.4,
    AREA: 0.2,
    ZONE: 0.5,
    CLUSTER_STROKE: 0.5,
  },
  MAPBOX_FIT_BOUNDS_PADDING: {
    top: 50,
    bottom: 50,
    left: 125,
    right: 125,
  },
  MAPBOX_CLUSTER_TEXT_SIZE: 12,
  MAPBOX_CLUSTER_FONT: ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
  MAPBOX_CLUSTER_CIRCLE_RADIUS: 18,
  MAPBOX_ZOOM_AFTER_M_SECONDS: 1500,
  MAPBOX_ICONS: [
    {
      name: 'icon-red',
      icon: mapsIconRed,
    },
    {
      name: 'icon-yellow',
      icon: mapsIconYellow,
    },
    {
      name: 'icon-green',
      icon: mapsIconGreen,
    },
    {
      name: 'icon-multi',
      icon: mapsIconMulti,
    },
    {
      name: 'icon-pin',
      icon: mapsIconPinBlue,
    },
  ],
}

export default config
